import { gql } from '@apollo/client';

export const CREATE_NEW_PAYMENT_METHOD_MUTATION = gql`
  mutation CreateNewPaymentMethod($type: String, $cardNumber: BigInt, $expiryMonth: Int, $expiryYear: Int, $cvc: String, $country: String, $currency: String, $accountHolderName: String, $routingNumber: String, $accountNumber: String, $clientId: ID) {
  createNewPaymentMethod(type: $type, card_number: $cardNumber, expiry_month: $expiryMonth, expiry_year: $expiryYear, cvc: $cvc, country: $country, currency: $currency, account_holder_name: $accountHolderName, routing_number: $routingNumber, account_number: $accountNumber, client_id: $clientId) {
    message
    data {
      stripe_id
      card_id
    }
  }
}
`